/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupePlusIcon16Light = forwardRef('SearchLoupePlusIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7 5.5a.5.5 0 0 0-1 0V7H4.5a.5.5 0 0 0 0 1H6v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H7V5.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.751 7.5a5.749 5.749 0 1 1 10.152 3.696l2.706 2.705a.5.5 0 1 1-.707.707l-2.706-2.705A5.749 5.749 0 0 1 .751 7.5ZM6.5 2.75a4.749 4.749 0 1 0 0 9.498 4.749 4.749 0 0 0 0-9.498Z" })));
});
